import axios from 'axios'
import store from '../store'

const axiosConfig = {
  baseURL: ''
}

const HTTP = axios.create(axiosConfig)
HTTP.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
HTTP.defaults.headers.common['Access-Control-Allow-Headers'] = 'Content-Type'
HTTP.defaults.headers.common['Access-Control-Allow-Methods'] = 'OPTIONS,POST,GET,PUT,DELETE'

let numberOfAjaxCAllPending = 0

const state = {
  loadingAxios: false
}

const getters = {
  loadingAxios: state => state.loadingAxios
}

const mutations = {
  'SET_LOADER_AXIOS' (state, payload) {
    state.loadingAxios = payload
  }
}

// Add a request interceptor
HTTP.interceptors.request.use(function (config) {
  // set baseURL from config File
  config.baseURL = store.getters.configFile.baseURL
  numberOfAjaxCAllPending++
  // show loader
  store.commit('SET_LOADER_AXIOS', true)
  return config
}, function (error) {
  return Promise.reject(error)
})

// Add a response interceptor
HTTP.interceptors.response.use(function (response) {
  numberOfAjaxCAllPending--
  if (numberOfAjaxCAllPending === 0) {
    // hide loader
    store.commit('SET_LOADER_AXIOS', false)
  }
  return response
}, function (error) {
  numberOfAjaxCAllPending--
  if (numberOfAjaxCAllPending === 0) {
    // hide loader
    store.commit('SET_LOADER_AXIOS', false)
  }
  return Promise.reject(error)
})

export default {
  HTTP,
  state,
  getters,
  mutations
}
